import { Component, Input } from '@angular/core';

interface CardOptions {
    title: string;
    titleTooltip: string;
    color: string;
    helpText: string;
}

@Component({
    selector: 'card',
    template: `
        <div class="pi-card">
            <div
                card-inner
                [title]="options.title"
                [titleTooltip]="options.titleTooltip"
                [helpText]="options.helpText"
                class="pi-card_front"
                [ngClass]="getClasses()"
                [showMe]="showMe"
            >
                <ng-content cardTools select="[cardTools]"> </ng-content>
                <ng-content cardContent select="[cardContent]"> </ng-content>
            </div>
        </div>
    `,
    standalone: false
})
export class CardComponent {
    @Input()
    options: CardOptions;
    @Input()
    showMe = true;

    getClasses() {
        const classArray = [];
        if (this.options && this.options.color) {
            classArray.push(this.options.color);
        }
        if (this.options && this.options.helpText) {
            classArray.push('pi-card--hasHelpText');
        }
        if (this.showMe) {
            classArray.push('pi-card_open');
        }
        return classArray.join(' ');
    }
}
